import React, { useState, useCallback, useEffect } from 'react';
import { Chart, Series, Legend, ValueAxis, Tooltip,
  AggregationInterval, ArgumentAxis, Label, ZoomAndPan,
  TickInterval, CommonSeriesSettings, } from 'devextreme-react/chart';
import { SelectBox } from 'devextreme-react/select-box';
import { Button } from 'devextreme-react/button';
import { Tooltip as TTooltip } from 'devextreme-react/tooltip';
import { TagBox } from 'devextreme-react/tag-box';
import { groupBy, calcWeightDataESG, Array_Average, Quartile } from '../../utils/miscUtil';
import { AvgTable } from '../'

const filter_fields = [
  "13", "14", "24", "25",
  "16", "17", "18",
  "19", "20", "21",
  "9",
  "3", "8",
  "10", "23",
  "1", "2", "6", "7", "5",
  "12",
  "22",
  "11",
  "27", "28", "29",
  "30", "31", "33",
];

export default function ESGQuantitativeMetricsOvG(props) {
  const [originalData, setOriginalData] = useState();
  const [data1, setData1] = useState();
  const [data2, setData2] = useState();
  const [companiesList, setCompaniesList] = useState([]);
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [selectedCompaniesList, setSelectedCompaniesList] = useState([]);
  const [reportingCompanies1, setReportingCompanies1] = useState([]);
  const [reportingCompanies2, setReportingCompanies2] = useState([]);
  const [metrics, setMetrics] = useState();
  const [metric, setMetric] = useState(null);
  const [unit, setUnit] = useState(null);
  const [boundaries, setBoundaries] = useState([]);
  const [boundary, setBoundary] = useState(null);
  const [weightData, setWeightData] = useState({});
  const [avgData1, setAvgData1] = useState(null);
  const [avgData2, setAvgData2] = useState(null);

  useEffect(() => {
    let wd = calcWeightDataESG(props.data, (parseInt(props.year)-1).toString());
    setWeightData(wd);
    var fd = props.data.filter((e) => {return filter_fields.includes(e["Identifier"])});
    var fd1 = groupBy(fd, 'company_name')
    setAllCompaniesList(Object.keys(fd1).sort())
    for (var i=0; i<fd.length; i++) {
      fd[i]['company_'+fd[i].company_name.toLowerCase().replaceAll(" ","_")] = parseFloat(fd[i].value?.replaceAll(",","")) || null;
      fd[i]['date'] = new Date(fd[i]['year'], 0)
    }
    setOriginalData(fd);
    fd = groupBy(fd, 'Metrics')
    setMetrics(Object.keys(fd).sort());
    fd = props.data.filter((e) => {return filter_fields.includes(e["Identifier"])});
    fd = groupBy(fd, 'Category')
    setBoundaries(Object.keys(fd).sort())
  }, [props.data, props.year]);



  const customizeTooltip = useCallback((pointInfo) => {
    var cn = ""
    if (pointInfo.seriesName.includes("Series")) {
      cn = "Company "+pointInfo.seriesName.split(" ")[1]
    } else {
      cn = pointInfo.seriesName
    }
    const y = pointInfo.argument.toLocaleString('default', {year: 'numeric'});
    var txt = ''
    txt = `<div><div class="tooltip-header">${y}</div><div class="tooltip-body">`
    txt = txt+`<div>${cn}: ${pointInfo.value}</div>`
    txt=txt+`</div></div>`
    return {
      html: txt,
    }
  }, []);

  const customizeTooltip2 = useCallback((pointInfo) => {
    const y = pointInfo.argument.toLocaleString('default', { year: 'numeric'});
    var txt = ''
    txt = `<div><div class="tooltip-header">${y} - ${pointInfo.value} Companies</div></div>`
    return {
      html: txt,
    }
  }, []);

  const onMetricChanged = useCallback((e) => {
    setMetric(e.value);
    let u = originalData.filter((it) => it["Metrics"].includes(e.value))
    if (u.length) {
      u = Object.keys(groupBy(u,"Units"))
      setUnit(u[0]);
    } else {
      setUnit(null);
    }

  }, [setMetric, setUnit, originalData])

  const onBoundaryChanged = useCallback((e) => {
    setBoundary(e.value);
    if (e.value) {
      if (e.value.length) {
        let ml = Object.keys(groupBy(originalData.filter((it) => e.value.includes(it["Category"])),"Metrics"))
        if (!ml.includes(metric)) {
          setMetric(null)
        }
        setMetrics(ml.sort());
      } else {
        setMetrics(Object.keys(groupBy(originalData,"Metrics")).sort());
      }
    }

  }, [setBoundary, setMetrics, originalData, metric, setMetric])

  const onCompaniesChanged = useCallback((e) => {
    setSelectedCompaniesList(e.value);
  }, [setSelectedCompaniesList])

  useEffect(() => {
    if (!originalData) {
      return;
    }
    var fd = originalData
    if (selectedCompaniesList.length) {
      fd = fd.filter((it) => selectedCompaniesList.includes(it['company_name']));
    }
    fd = fd.filter((it) => it['Metrics']===metric);

    var fd1 = groupBy(fd,"company_name");
    fd1 = Object.keys(fd1)
    var i;
    var fd2;
    var vals;
    var v;

    fd1 = fd1.map((key) => ({company_name:key}));
    fd1 = fd1.sort((a,b) => (a.company_name > b.company_name) ? 1 : ((b.company_name > a.company_name) ? -1 : 0));
    setCompaniesList(fd1);

    fd1 = groupBy(fd.filter((it) => "Oil".includes(weightData[it["company_name"]])),"year");
    for (const [key] of Object.entries(fd1)) {
      vals = [];
      v = 0;
      for (i=0; i<fd1[key].length; i++){
        v = parseFloat(fd1[key][i]["value"]);
        if (!isNaN(v)) {
          vals.push(v)
        }
      }
      fd1[key] = {avg: Array_Average(vals), q25: Quartile(vals, 0.25), q50: Quartile(vals, 0.50), q75: Quartile(vals, 0.75)};
    }
    fd1 = Object.keys(fd1).map((key) => ({date: new Date(key, 0), ...fd1[key]}));
    setAvgData1(fd1);

    fd2 = groupBy(fd.filter((it) => "Gas".includes(weightData[it["company_name"]])),"year");
    for (const [key] of Object.entries(fd2)) {
      vals = [];
      v = 0;
      for (i=0; i<fd2[key].length; i++){
        v = parseFloat(fd2[key][i]["value"]);
        if (!isNaN(v)) {
          vals.push(v)
        }
      }
      fd2[key] = {avg: Array_Average(vals), q25: Quartile(vals, 0.25), q50: Quartile(vals, 0.50), q75: Quartile(vals, 0.75)};
    }
    fd2 = Object.keys(fd2).map((key) => ({date: new Date(key, 0), ...fd2[key]}));
    setAvgData2(fd2);

    let fdo = fd.filter((it) => "Oil".includes(weightData[it["company_name"]]));
    let fdg = fd.filter((it) => "Gas".includes(weightData[it["company_name"]]))
    fdo.push(...fd1)
    setData1(fdo);
    fdg.push(...fd2)
    setData2(fdg);

    fdo = groupBy(fdo.filter((it) => !isNaN(parseFloat(it['value']?.replaceAll(",","")))),"year");
    fdo = Object.keys(fdo).map((key) => {
      return {date: new Date(key, 0) , count: fdo[key].length}
    });
    setReportingCompanies1(fdo);

    fdg = groupBy(fdg.filter((it) => !isNaN(parseFloat(it['value']?.replaceAll(",","")))),"year");
    fdg = Object.keys(fdg).map((key) => {
      return {date: new Date(key, 0) , count: fdg[key].length}
    });
    setReportingCompanies2(fdg);

  }, [props.data, props.year, metric, boundary, selectedCompaniesList, weightData, originalData]);

  const renderContent = () => {
      return (
          <div>Gas/Oil Weighting is calculated from Gross Annual Oil Production and<br/>
          Gross Annual Production - As Reported Under Subpart W. Companies that <br/>
          did not report both of these metrics were not assigned a weighting.</div>
      );
  }

  return (
    <div className="d-flex flex-column">
      <div className="d-flex flex-row">
        <TagBox
            dataSource={allCompaniesList}
            value={selectedCompaniesList}
            showDropDownButton={true}
            width="50%"
            activeStateEnabled={true}
            multiline={false}
            maxDisplayedTags={1}
            showSelectionControls={true}
            onValueChanged={onCompaniesChanged}
            label={"Company"}
            labelMode="floating"
            placeholder={"Select Companies"}
        />
        <div className="mx-1"/>
        <TagBox
            dataSource={boundaries}
            value={boundary}
            width="50%"
            showDropDownButton={true}
            activeStateEnabled={true}
            onValueChanged={onBoundaryChanged}
            multiline={false}
            maxDisplayedTags={1}
            showSelectionControls={true}
            label={"Category"}
            labelMode="floating"
            placeholder={"Select Category"}
        />
      </div>
      <div className="d-flex flex-row align-items-end">
        <SelectBox
            dataSource={metrics}
            showDropDownButton={true}
            width="100%"
            activeStateEnabled={true}
            placeholder={"Select Metric"}
            label={"Metric"}
            labelMode="floating"
            onValueChanged={onMetricChanged}
        />
      </div>
      <hr className="mt-1 mb-2"></hr>
      <div className="d-flex flex-row">
        <div className="d-flex flex-column w-100">
          {metric ?
            <div className="d-flex flex-row">
              <h5>{metric}</h5>
              <div>
                <Button
                  id="moreweight2"
                  icon='fas fa-info-circle'
                  stylingMode="text"
                  type="normal"
                />
                <TTooltip
                    target="#moreweight2"
                    showEvent="mouseenter"
                    hideEvent="mouseleave"
                    contentRender={renderContent}
                />
              </div>
            </div>
            :<h5>Select a metric...</h5>
          }
          {unit && <p>({unit})</p>}
        </div>
      </div>
      <div className="d-flex flex-row">
        <div className="d-flex flex-column" style={{width:"50%"}}>
          <Chart
            id="chart"
            dataSource={data1}
            height="50vh"
            title="Oil Weighted"
          >
            <ArgumentAxis aggregatedPointsPosition="crossTicks">
              <AggregationInterval years={1} />
              <TickInterval years={1} />
            </ArgumentAxis>
            <CommonSeriesSettings
              argumentField="date"
            >
            </CommonSeriesSettings>
            {companiesList.map((e) => (<Series
              type="bar"
              key={e.company_name}
              valueField={"company_"+e.company_name.toLowerCase().replaceAll(" ","_")}
              showInLegend={false}
              name={e.company_name}
              color="rgba(0, 162, 200, 0.8)"
              ignoreEmptyPoints={true}
            />))}
            <Series
              type="line"
              valueField="avg"
              name="Average"
              color="rgba(20, 77, 109, 1)"
              dashStyle="solid"
            />
            <Series
              type="line"
              valueField="q25"
              name="1st Quartile"
              color="rgba(20, 77, 109, 0.25)"
              dashStyle="dot"
            />
            <Series
              type="line"
              valueField="q50"
              name="2nd Quartile"
              color="rgba(20, 77, 109, 0.5)"
              dashStyle="dash"
            />
            <Series
              type="line"
              valueField="q75"
              name="3rd Quartile"
              color="rgba(20, 77, 109, 0.75)"
              dashStyle="longDash"
            />
            <ValueAxis showZero={false} />

            <Legend
              verticalAlignment="bottom"
              horizontalAlignment="center"
              itemTextPosition="bottom"
            />
            <ZoomAndPan
              valueAxis="both"
              argumentAxis="both"
              dragToZoom={true}
              allowMouseWheel={true}
              panKey="shift"
            />
            <Tooltip
              enabled={true}
              customizeTooltip={customizeTooltip}
            />
          </Chart>
          <AvgTable data={avgData1}/>
          <Chart
            id="chart"
            dataSource={reportingCompanies1}
            title={"Oil Weighted Reporting Companies"}
            rotated={true}
            height="200px"
          >
            <ArgumentAxis aggregatedPointsPosition="crossTicks">
              <AggregationInterval years={1} />
              <TickInterval years={1} />
            </ArgumentAxis>
            <CommonSeriesSettings
              argumentField="date"
            >
            </CommonSeriesSettings>
            <Series
              type="bar"
              valueField={"count"}
              color="rgba(0, 162, 200, 0.8)"
            >
              <Label visible={true}/>

            </Series>

            <ValueAxis showZero={true} allowDecimal={false} tickInterval={5}>
            </ValueAxis>
            <Legend visible={false} />
            <Tooltip
              enabled={true}
              customizeTooltip={customizeTooltip2}
            />
          </Chart>
        </div>
        <div className="d-flex flex-column" style={{width:"50%"}}>
          <Chart
            id="chart"
            dataSource={data2}
            height="50vh"
            title="Gas Weighted"
          >
            <ArgumentAxis aggregatedPointsPosition="crossTicks">
              <AggregationInterval years={1} />
              <TickInterval years={1} />
            </ArgumentAxis>
            <CommonSeriesSettings
              argumentField="date"
            >
            </CommonSeriesSettings>
            {companiesList.map((e) => (<Series
              type="bar"
              key={e.company_name}
              valueField={"company_"+e.company_name.toLowerCase().replaceAll(" ","_")}
              showInLegend={false}
              name={e.company_name}
              color="rgba(0, 162, 200, 0.8)"
              ignoreEmptyPoints={true}
            />))}
            <Series
              type="line"
              valueField="avg"
              name="Average"
              color="rgba(20, 77, 109, 1)"
              dashStyle="solid"
            />
            <Series
              type="line"
              valueField="q25"
              name="1st Quartile"
              color="rgba(20, 77, 109, 0.25)"
              dashStyle="dot"
            />
            <Series
              type="line"
              valueField="q50"
              name="2nd Quartile"
              color="rgba(20, 77, 109, 0.5)"
              dashStyle="dash"
            />
            <Series
              type="line"
              valueField="q75"
              name="3rd Quartile"
              color="rgba(20, 77, 109, 0.75)"
              dashStyle="longDash"
            />
            <ValueAxis showZero={false} />

            <Legend
              verticalAlignment="bottom"
              horizontalAlignment="center"
              itemTextPosition="bottom"
            />
            <ZoomAndPan
              valueAxis="both"
              argumentAxis="both"
              dragToZoom={true}
              allowMouseWheel={true}
              panKey="shift"
            />
            <Tooltip
              enabled={true}
              customizeTooltip={customizeTooltip}
            />
          </Chart>
          <AvgTable data={avgData2}/>
          <Chart
            id="chart"
            dataSource={reportingCompanies2}
            title={"Gas Weighted Reporting Companies"}
            rotated={true}
            height="200px"
          >
            <ArgumentAxis aggregatedPointsPosition="crossTicks">
              <AggregationInterval years={1} />
              <TickInterval years={1} />
            </ArgumentAxis>
            <CommonSeriesSettings
              argumentField="date"
            >
            </CommonSeriesSettings>
            <Series
              type="bar"
              valueField={"count"}
              color="rgba(0, 162, 200, 0.8)"
            >
              <Label visible={true}/>

            </Series>

            <ValueAxis showZero={true} allowDecimal={false} tickInterval={5}>
            </ValueAxis>
            <Legend visible={false} />
            <Tooltip
              enabled={true}
              customizeTooltip={customizeTooltip2}
            />
          </Chart>
        </div>
      </div>
    </div>
  );
}
